import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ChecklistService } from '../../../services/checklist';
import { switchMap } from 'rxjs/operators';
import { Checklist } from '../../../classes/checklist';
import { from } from 'rxjs';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import {GeneralModalComponent} from "../../../modals/general/general-modal/general-modal.component";

@Component({
  selector: 'app-checklist-general',
  templateUrl: './checklist-general.component.html',
  styleUrls: ['./checklist-general.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ChecklistGeneralComponent implements OnInit {

  // Pagination Parameters
  paginationConfig = {
    itemsPerPage: 10,
    currentPage: 1
  };
  paginationParams = {
    autoHide: true,
    maxSize: 7,
    responsive: true
  };
  paginationLabels = {
    previousLabel: 'Precedente',
    nextLabel: 'Successiva',
    screenReaderPaginationLabel: 'Paginazione',
    screenReaderPageLabel: 'pagina',
    screenReaderCurrentLabel: `Sei sulla pagina`
  };

  // Filters
  checklistFilterValue!: string;
  checklistTitleFilterValue!: string;
  checklistDescriptionFilterValue!: string;

  // Checklists data
  checklists: Array<Checklist> = [];

  constructor(private checklistService: ChecklistService,
              private modalService: NgbModal) { }

  ngOnInit(): void {
    this.checklistService.getAll()
      .pipe(
        switchMap((checklistsData: any) => from(checklistsData))
      )
      .subscribe({
        next: (checklist: any) => {
          this.checklists.push(checklist);
        },
        error: e => {
          console.log('Error: ' + e);
        }
      });
  }

  onPageChange(pageNumber: number) {
    this.paginationConfig.currentPage = pageNumber;
  }

  onPageBoundsCorrection(pageNumber: number) {
    this.paginationConfig.currentPage = pageNumber;
  }

  openDeleteChecklistModal(checklist: Checklist) {
    const modalRef = this.modalService.open(GeneralModalComponent);
    modalRef.componentInstance.title = 'Rimozione <strong>Checklist</strong>';
    modalRef.componentInstance.text = 'Confermi la rimozione della checklist "' + checklist.name + '"?';
    modalRef.result.then(() => {
      if (checklist.id_checklist) {
        this.checklistService.delete(checklist.id_checklist)
            .subscribe({
              next: () => {
                this.checklists = this.checklists.filter((currChecklist: Checklist) => currChecklist.id_checklist !== checklist.id_checklist);
                this.paginationConfig.currentPage = 1;
              },
              error: (err: HttpErrorResponse) => {
                console.log(err);
              }
            });
      }
    });
  }

}
